import React, { useState } from 'react'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import LABEL from '../../../business-const/Label/Label'

import {
    descricaoMenu,
} from '../../../business-components/String/String'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    TabsPadrao,
    TabPadrao,
} from '../../../business-components/Tab/Tab'

import {
    indexMenu,
} from '../../../business-rules/List/ListService'

import tabEstudoFormParametrosList from '../../../business-rules/List/tabEstudoFormParametrosList'

import {
    EstudoFormCenarios
} from './EstudoFormCenarios'

import EstudoFormCenariosTaxas from './EstudoFormCenariosTaxas'

import EstudoFormClienteConjuge from './EstudoFormClienteConjuge'

import EstudoFormExclusao from './EstudoFormExclusao'

import EstudoFormConfiguracaoGestaoPatrimonial from './EstudoFormConfiguracaoGestaoPatrimonial'

import EstudoFormConfiguracaoAcumulacao from './EstudoFormConfiguracaoAcumulacao'

import EstudoFormConfiguracaoProtecao from './EstudoFormConfiguracaoProtecao'

import EstudoFormPaginaAdicional from './EstudoFormPaginaAdicional'

import EstudoFormConfiguracaoRelatorio from './EstudoFormConfiguracaoRelatorio'



const EstudoFormParametros = ({ variaveisGlobais, values, handleChange, handleSubmit, setFieldValue, vars }) => {

    const tabEstudoFormParametrosListAux = tabEstudoFormParametrosList(values, vars.linhaTipoLicenca)
    
    const [tabIndexEstudoParametros, setTabIndexEstudoParametros] =
        useState(tabEstudoFormParametrosListAux.length - 1 < values.tabIndexEstudoParametros ? 0 : values.tabIndexEstudoParametros)

    const handleTabChangeEstudoParametros = (e, value) => {
        values.tabIndexEstudoParametros = value

        setTabIndexEstudoParametros(value)
    }

    useSingleton(async () => {

        let indexMenuAux = null



        if (
                values.tabEstudoFormList === LABEL.acumulacao || values.tabEstudoFormList === LABEL.conferenciaDados ||
                values.tabEstudoFormList === LABEL.gestaoPatrimonialProjecaoFutura
        ) {

            indexMenuAux = indexMenu(tabEstudoFormParametrosListAux, LABEL.configuracaoAcumulacao)

        } else {
            
            if (
                    values.tabEstudoFormList === LABEL.protecao ||
                    values.tabEstudoFormList === LABEL.gestaoPatrimonialSucessao
            ) {

                indexMenuAux = indexMenu(tabEstudoFormParametrosListAux, LABEL.configuracaoProtecao)

            } else {
                    
            if (
                    values.tabEstudoFormList === LABEL.gestaoPatrimonial || 
                    values.tabEstudoFormList === LABEL.gestaoPatrimonialEstrategiasFinanceiras
            ) {

                indexMenuAux = indexMenu(tabEstudoFormParametrosListAux, LABEL.configuracaoGestaoPatrimonial)

            } else {
                
                    if (values.tabEstudoFormList === LABEL.relatorio) {
    
                        indexMenuAux = indexMenu(tabEstudoFormParametrosListAux, LABEL.configuracaoRelatorio)
                    }
                }
            }
        }

        if (indexMenuAux !== null) {

            handleTabChangeEstudoParametros(null, indexMenuAux)
        }
    })
      
    

    return (
        <DivForm>
             <EstudoFormCenarios
                values={values}
                handleChange={handleChange}
                handleSubmit={handleSubmit}
                setFieldValue={setFieldValue}
            />
            <TabsPadrao
                value={tabIndexEstudoParametros}
                onChange={handleTabChangeEstudoParametros}
                level={3}
            >
                {tabEstudoFormParametrosListAux?.map((item, ind) => (
                    <TabPadrao
                        value={ind}
                        label={item}
                        key={ind}
                        level={3}
                    />
                ))}
            </TabsPadrao>
            {descricaoMenu(tabEstudoFormParametrosListAux[tabIndexEstudoParametros]) === LABEL.cenariosTaxas && (
                <EstudoFormCenariosTaxas
                    values={values}
                    handleChange={handleChange}
                    handleSubmit={handleSubmit}
                    setFieldValue={setFieldValue}
                    linhaTipoLicenca={vars.linhaTipoLicenca}
                />
            )}
            {descricaoMenu(tabEstudoFormParametrosListAux[tabIndexEstudoParametros]) === LABEL.idades && (
                <EstudoFormClienteConjuge
                    values={values}
                    handleChange={handleChange}
                    handleSubmit={handleSubmit}
                />
            )}
            {descricaoMenu(tabEstudoFormParametrosListAux[tabIndexEstudoParametros]) === LABEL.exclusoes && (
                <EstudoFormExclusao
                    values={values}
                    handleChange={handleChange}
                    handleSubmit={handleSubmit}
                />
            )}
            {descricaoMenu(tabEstudoFormParametrosListAux[tabIndexEstudoParametros]) === LABEL.configuracaoAcumulacao && (
                <EstudoFormConfiguracaoAcumulacao
                    values={values}
                    handleChange={handleChange}
                    handleSubmit={handleSubmit}
                />
            )}
            {descricaoMenu(tabEstudoFormParametrosListAux[tabIndexEstudoParametros]) === LABEL.configuracaoProtecao && (
                <EstudoFormConfiguracaoProtecao
                    values={values}
                    handleChange={handleChange}
                    handleSubmit={handleSubmit}
                    vars={vars}
                />
            )}
            {descricaoMenu(tabEstudoFormParametrosListAux[tabIndexEstudoParametros]) === LABEL.configuracaoGestaoPatrimonial && (
                <EstudoFormConfiguracaoGestaoPatrimonial
                    values={values}
                    handleChange={handleChange}
                    handleSubmit={handleSubmit}
                    //popup={false}
                />
            )}
            {descricaoMenu(tabEstudoFormParametrosListAux[tabIndexEstudoParametros]) === LABEL.paginaAdicional && (
                <EstudoFormPaginaAdicional
                    values={values}
                    handleChange={handleChange}
                    handleSubmit={handleSubmit}
                    setFieldValue={setFieldValue}
                    vars={vars}
                />
            )}
            {descricaoMenu(tabEstudoFormParametrosListAux[tabIndexEstudoParametros]) === LABEL.configuracaoRelatorio && (
                <EstudoFormConfiguracaoRelatorio
                    variaveisGlobais={variaveisGlobais}
                    values={values}
                    handleChange={handleChange}
                    handleSubmit={handleSubmit}
                    setFieldValue={setFieldValue}
                    linhaTipoLicenca={vars.linhaTipoLicenca}
                    jsonPagina={vars.jsonPagina}
                    jsonUsuario={vars.jsonUsuario}
                    jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                />
            )}   
        </DivForm>
    )
}

export default EstudoFormParametros